import React from 'react';
import { useLocation } from 'react-router-dom';
import { Logo } from '@nearst/ui';
import { useShop } from '@services/ShopProvider';
import UnifyLogoImage from '../../assets/logo/unify-logo.png';
import styles from './Sidebar.module.scss';

export const ConditionalLogo = () => {
	const location = useLocation();
	const { shop } = useShop() || {};

	// Check if we should show Unify logo
	const isUnifyOnboardingPage = location.pathname === '/unify-onboarding';
	const hasUnifyPlan = shop?.plan?.startsWith('unify');
	const showUnifyLogo = isUnifyOnboardingPage || hasUnifyPlan;

	if (showUnifyLogo) {
		return <img src={UnifyLogoImage} alt="Unify" height="80" className={styles.logo} style={{ display: 'block' }} />;
	}

	return <Logo height="24px" className={styles.logo} style={{ display: 'block' }} />;
};
